import '@/app/app.css';
import './catalog.css';

import '@/app/app';

import {SliderProducts} from '@/features/slider-products/slider-products';
import {
	CatalogFiltersCheckboxListExpand
} from '@/features/catalog/catalog-filters-checkbox-list/catalog-filters-checkbox-list';
import {
	CatalogFiltersListSearch
} from '@/features/catalog/catalog-filters-list/catalog-filters-list';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));

	const elements = document.querySelectorAll('.js-filter-checkbox-list');
	elements.forEach(el => new CatalogFiltersCheckboxListExpand(el));

	const listsElements = document.querySelectorAll('.filter-checkbox-list__search');
	listsElements.forEach(el => new CatalogFiltersListSearch(el));
});
